import { ModalConfirmationTextures } from '@components/GenericModals/ModalConfirmationTextures'
import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useAppStore } from '@store'
import { Store } from '@types'
import { useState } from 'react'

export function LinkedGroupSearch() {
  const applyToAllItems = useAppStore((s) => s.applyToAllItemsAndChildrens)
  const applyChildrenAndZonesToAllItems = useAppStore(
    (s) => s.applyAllZonesAndChildrenOfLinkedToAnotherLinkedWithTheSameName,
  )
  const { object, highlighted } = useLinkedContext()

  const [id, zone] = highlighted.split('!')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState({
    text: '',
    onConfirm: () => {},
  })

  
  const objectName = object.current?.description

  function openModalWithContent(text, onConfirm) {
    setModalContent({ text, onConfirm })
    setIsModalOpen(true)
  }

  function handleApplyToAllItems() {
    applyToAllItems(id)
  }

  function handleApllyChildrenAndZones() {
    applyChildrenAndZonesToAllItems(id)
  }

  return (
    <>
      <div className='mb-2 flex w-56 content-end justify-center'>
        <section className='pointer-events-none invisible opacity-0'>
          <section className='mt-auto flex items-center justify-center'>
            <div className='flex w-[288px] flex-col rounded-lg bg-C/Color10 p-2 shadow-md'>
              <button
                className='w-[278px] cursor-pointer rounded-md border border-solid border-C/Color7 bg-C/Color3 py-0.5 text-[10px] text-C/Color1'
                onClick={() =>
                  openModalWithContent(
                    `${'¿Quiere copiar los acabados de todas las zonas de la unidad'} ${objectName}, ${'en todas las zonas con el mismo nombre de todas las unidades del diseño?'}`,
                    handleApllyChildrenAndZones,
                  )
                }
              >
                {'Copiar toda la unidad acabados e hijos seleccionados'}
              </button>
              <button
                className='w-[278px] cursor-pointer rounded-md border border-solid border-C/Color7 bg-C/Color3 py-0.5 text-[10px] text-C/Color1'
                onClick={() =>
                  openModalWithContent(
                    `${'¿Quiere copiar los acabados de todas las zonas de la unidad'} ${objectName}, ${'en todas las zonas con el mismo nombre de todas las unidades del diseño?'}`,
                    handleApplyToAllItems,
                  )
                }
              >
                {'Copiar Hijos y Zonas en unidades iguales'}
              </button>
            </div>
            {isModalOpen && (
              <ModalConfirmationTextures
                text={modalContent.text}
                onConfirm={modalContent.onConfirm}
                closeModal={() => setIsModalOpen(false)}
              />
            )}
          </section>
        </section>
        <div className='absolute w-[1980px] border-t-2 border-C/Color3 '></div>
      </div>
    </>
  )
}
